import { render } from "./Notification.vue?vue&type=template&id=616164a8&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import "./Notification.vue?vue&type=style&index=0&id=616164a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-616164a8"

export default script